<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="modal__wrapper">
      <div class="modal__header">
        <div class="modal__title" data-cy="modal-title">
          <h3>{{ title }}</h3>
        </div>
        <button
          *ngIf="!withoutClose"
          type="button"
          class="modal__close"
          (click)="closeModal()"
          data-cy="modal-close"
        >
          <em class="fas fa-times"></em>
        </button>
      </div>

      <div class="modal__body">
        <ng-container *ngIf="(loaded$ | async) || modalIsOpen; else loading">
          <p>
            {{ description }}
          </p>

          <div slot="content">
            <eb-spinner alignment="center" width="100%"></eb-spinner>
          </div>

          <div class="modal__actions">
            <ng-content select="[slot=actions]"></ng-content>
          </div>
        </ng-container>

        <ng-template #loading>
          <eb-spinner></eb-spinner>
        </ng-template>
      </div>
    </div>
  </div>
</div>
